import React, { useEffect } from 'react';
import Layout from '../layouts/Layout';
import { PUBLIC_URL } from '../utils/const';
import { BlogLanguageWrapper, BlogPage } from 'reactyll';
import MarkDown from 'react-markdown'
import rehypeRaw from 'rehype-raw';
import { Head } from 'vite-react-ssg';
import { useFathom } from '../contexts/FathomContext';
import { Container, Title, Text, Image, Box, Paper, Anchor, Group, Button, Stack, Divider } from '@mantine/core';
import { redirectWithParameters } from '../utils/common';
import { getBlogByLanguage } from '../utils/blog';
import { blogs } from '../_blog/routes';
import { useTranslation } from 'react-i18next';
import MoreFromOurBlog from '../components/MoreFromOurBlog';

export interface ExtraProperties {
    date: string
    headline: string
    description: string
    publishDate: string
    readMore?: string[]
}

const content: BlogPage<ExtraProperties> = JSON.parse(decodeURIComponent(atob(`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`)));


const InnerBlogTemplate: React.FC = () => {
    const { trackEvent } = useFathom();
    const { i18n } = useTranslation();

    const matchingLanguageCode = content.properties.language || i18n.resolvedLanguage;    
    
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const langParam = urlParams.get('lang');

        if (langParam) {
            const matchingLanguage = content.languages.find(([lang, url]) => lang === langParam);
            if (matchingLanguage) {
                const [_, url] = matchingLanguage;
                window.location.href = `${url}`;
            }
        }
        

        const handleButtonClick = (event: any) => {
            if (event.target.classList.contains('cta')) {
                console.log("CTA clicked")
                trackEvent("Blog > CTA Clicked");
                window.location.href = "/login?signup=true"
            }
        };

        const parentElement = document.getElementById('blog-wrapper');
        if (parentElement) {
            document.addEventListener('click', handleButtonClick);
        }

        return () => {
            if (parentElement) {
                parentElement.removeEventListener('click', handleButtonClick);
            }
        };
    }, []);

    return (
        <Box bg="gray.0">
            <Head>
                <meta charSet="utf-8" />
                <title>{content.properties.title}</title>
                <link rel="canonical" href={`https://calensync.live${content.properties.url}`} />
                {content.languages.map(([language, url]) => (
                    <link rel="alternate" key={language} href={`https://calensync.live${url}`} hrefLang={language} />
                ))}
                <meta name="description" content={content.properties.description} />
                <meta property="og:title" content={content.properties.title} />
                <meta property="og:url" content={`https://calensync.live${content.properties.url}`} />
                <meta property="og:description" content={content.properties.description} />
                <meta property="og:publish_date" content={content.properties.publishDate} />
            </Head>
            <Container size="md" mt="md" id="blog-wrapper">
                <Paper p="md" my="md" bg="gray.0">
                    <Box mb="md" mt="md">
                        <Title order={1} mb="xs">{content.properties.title}</Title>
                        <Text fs="italic" c="dimmed">{content.properties.date}</Text>
                    </Box>

                    <Box mb="xl">
                        <MarkDown
                            rehypePlugins={[rehypeRaw]}
                            children={content.markdown}
                            components={{
                                h1(props) {
                                    const { children } = props
                                    return <Title order={1}>{children}</Title>
                                },
                                p(props) {
                                    const { children } = props
                                    return <Text size="lg" mb="md">
                                        {children}
                                    </Text>
                                },
                                strong(props) {
                                    const { children } = props
                                    return <Text span fw={700}><b>{children}</b></Text>
                                },
                                h2(props) {
                                    const { children } = props
                                    return <Title fw={400} order={2} mt="xl" pt="md" pb="md">{children}</Title>
                                },
                                h3(props) {
                                    const { children } = props
                                    return <Title fz="xl" fw={300} order={3} mt="md" pt="sm" pb="sm">{children}</Title>
                                },
                                img(props) {
                                    const { src, alt, style, width } = props
                                    return <Image
                                        mx="auto"
                                        my="sm"
                                        src={src}
                                        alt={alt}
                                        style={style}
                                        w={width}
                                        radius="md"
                                    />
                                },
                                a(props) {
                                    const { children, href } = props
                                    if (typeof children === 'string' && children.includes('CUSTOM_BUTTON')) {
                                        const content = children.replace('CUSTOM_BUTTON:', '')
                                        const onClick = () => {
                                            console.log("CTA clicked")
                                            trackEvent("Blog > CTA Clicked");
                                            redirectWithParameters('login', { signup: 'true' }, true)
                                        }
                                        return (
                                            <Group justify='center' my='md'>
                                                <Stack justify='center' my='md' gap="0">
                                                    <Button color="primary.4" size="compact-md" className="cta" onClick={onClick}>{content}</Button>
                                                    <Text size="sm" c="dimmed">.. and get 7 days free trial</Text>
                                                </Stack>
                                            </Group>
                                        )
                                    } else if (href.toLowerCase().startsWith('blog/')) {
                                        const blogId = href.toLowerCase().replace('blog/', '')
                                        const content = getBlogByLanguage(blogs[blogId], matchingLanguageCode)
                                        return <Anchor href={content.url}>{children}</Anchor>
                                    } else {
                                        return <Anchor href={href}>{children}</Anchor>
                                    }
                                }
                            }}
                        />
                    </Box>
                    {content.properties.readMore && (
                        <MoreFromOurBlog 
                            blogs={content.properties.readMore.map((blogId) => blogs[blogId])} 
                            matchingLanguageCode={matchingLanguageCode} 
                        />
                    )}
                </Paper>
            </Container>
        </Box>
    );
};

const BlogTemplate: React.FC = () => {
    return (
        <Layout>
            <InnerBlogTemplate />
        </Layout>
    );
};

export default BlogTemplate;